import React, { useEffect } from 'react';
import Layout from '../layouts/Layout';
import { PUBLIC_URL } from '../utils/const';
import { BlogLanguageWrapper, BlogPage } from 'reactyll';
import MarkDown from 'react-markdown'
import rehypeRaw from 'rehype-raw';
import { Head } from 'vite-react-ssg';
import { useFathom } from '../contexts/FathomContext';
import { Container, Title, Text, Image, Box, Paper, Anchor, Group, Button, Stack, Divider } from '@mantine/core';
import { redirectWithParameters } from '../utils/common';
import { getBlogByLanguage } from '../utils/blog';
import { blogs } from '../_blog/routes';
import { useTranslation } from 'react-i18next';
import MoreFromOurBlog from '../components/MoreFromOurBlog';

export interface ExtraProperties {
    date: string
    headline: string
    description: string
    publishDate: string
    readMore?: string[]
}

const content: BlogPage<ExtraProperties> = JSON.parse(decodeURIComponent(atob(`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`)));


const InnerBlogTemplate: React.FC = () => {
    const { trackEvent } = useFathom();
    const { i18n } = useTranslation();

    const matchingLanguageCode = content.properties.language || i18n.resolvedLanguage;    
    
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const langParam = urlParams.get('lang');

        if (langParam) {
            const matchingLanguage = content.languages.find(([lang, url]) => lang === langParam);
            if (matchingLanguage) {
                const [_, url] = matchingLanguage;
                window.location.href = `${url}`;
            }
        }
        

        const handleButtonClick = (event: any) => {
            if (event.target.classList.contains('cta')) {
                console.log("CTA clicked")
                trackEvent("Blog > CTA Clicked");
                window.location.href = "/login?signup=true"
            }
        };

        const parentElement = document.getElementById('blog-wrapper');
        if (parentElement) {
            document.addEventListener('click', handleButtonClick);
        }

        return () => {
            if (parentElement) {
                parentElement.removeEventListener('click', handleButtonClick);
            }
        };
    }, []);

    return (
        <Box bg="gray.0">
            <Head>
                <meta charSet="utf-8" />
                <title>{content.properties.title}</title>
                <link rel="canonical" href={`https://calensync.live${content.properties.url}`} />
                {content.languages.map(([language, url]) => (
                    <link rel="alternate" key={language} href={`https://calensync.live${url}`} hrefLang={language} />
                ))}
                <meta name="description" content={content.properties.description} />
                <meta property="og:title" content={content.properties.title} />
                <meta property="og:url" content={`https://calensync.live${content.properties.url}`} />
                <meta property="og:description" content={content.properties.description} />
                <meta property="og:publish_date" content={content.properties.publishDate} />
            </Head>
            <Container size="md" mt="md" id="blog-wrapper">
                <Paper p="md" my="md" bg="gray.0">
                    <Box mb="md" mt="md">
                        <Title order={1} mb="xs">{content.properties.title}</Title>
                        <Text fs="italic" c="dimmed">{content.properties.date}</Text>
                    </Box>

                    <Box mb="xl">
                        <MarkDown
                            rehypePlugins={[rehypeRaw]}
                            children={content.markdown}
                            components={{
                                h1(props) {
                                    const { children } = props
                                    return <Title order={1}>{children}</Title>
                                },
                                p(props) {
                                    const { children } = props
                                    return <Text size="lg" mb="md">
                                        {children}
                                    </Text>
                                },
                                strong(props) {
                                    const { children } = props
                                    return <Text span fw={700}><b>{children}</b></Text>
                                },
                                h2(props) {
                                    const { children } = props
                                    return <Title fw={400} order={2} mt="xl" pt="md" pb="md">{children}</Title>
                                },
                                h3(props) {
                                    const { children } = props
                                    return <Title fz="xl" fw={300} order={3} mt="md" pt="sm" pb="sm">{children}</Title>
                                },
                                img(props) {
                                    const { src, alt, style, width } = props
                                    return <Image
                                        mx="auto"
                                        my="sm"
                                        src={src}
                                        alt={alt}
                                        style={style}
                                        w={width}
                                        radius="md"
                                    />
                                },
                                a(props) {
                                    const { children, href } = props
                                    if (typeof children === 'string' && children.includes('CUSTOM_BUTTON')) {
                                        const content = children.replace('CUSTOM_BUTTON:', '')
                                        const onClick = () => {
                                            console.log("CTA clicked")
                                            trackEvent("Blog > CTA Clicked");
                                            redirectWithParameters('login', { signup: 'true' }, true)
                                        }
                                        return (
                                            <Group justify='center' my='md'>
                                                <Stack justify='center' my='md' gap="0">
                                                    <Button color="primary.4" size="compact-md" className="cta" onClick={onClick}>{content}</Button>
                                                    <Text size="sm" c="dimmed">.. and get 7 days free trial</Text>
                                                </Stack>
                                            </Group>
                                        )
                                    } else if (href.toLowerCase().startsWith('blog/')) {
                                        const blogId = href.toLowerCase().replace('blog/', '')
                                        const content = getBlogByLanguage(blogs[blogId], matchingLanguageCode)
                                        return <Anchor href={content.url}>{children}</Anchor>
                                    } else {
                                        return <Anchor href={href}>{children}</Anchor>
                                    }
                                }
                            }}
                        />
                    </Box>
                    {content.properties.readMore && (
                        <MoreFromOurBlog 
                            blogs={content.properties.readMore.map((blogId) => blogs[blogId])} 
                            matchingLanguageCode={matchingLanguageCode} 
                        />
                    )}
                </Paper>
            </Container>
        </Box>
    );
};

const BlogTemplate: React.FC = () => {
    return (
        <Layout>
            <InnerBlogTemplate />
        </Layout>
    );
};

export default BlogTemplate;